import React, { useEffect } from 'react';
import Layout from '../layouts/Layout';
import { PUBLIC_URL } from '../utils/const';
import { BlogLanguageWrapper, BlogPage } from 'reactyll';
import MarkDown from 'react-markdown'
import rehypeRaw from 'rehype-raw';
import { Head } from 'vite-react-ssg';
import { useFathom } from '../contexts/FathomContext';
import { Container, Title, Text, Image, Box, Paper, Anchor, Group, Button, Stack, Divider } from '@mantine/core';
import { redirectWithParameters } from '../utils/common';
import { getBlogByLanguage } from '../utils/blog';
import { blogs } from '../_blog/routes';
import { useTranslation } from 'react-i18next';
import MoreFromOurBlog from '../components/MoreFromOurBlog';

export interface ExtraProperties {
    date: string
    headline: string
    description: string
    publishDate: string
    readMore?: string[]
}

const content: BlogPage<ExtraProperties> = JSON.parse(decodeURIComponent(atob(`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`)));


const InnerBlogTemplate: React.FC = () => {
    const { trackEvent } = useFathom();
    const { i18n } = useTranslation();

    const matchingLanguageCode = content.properties.language || i18n.resolvedLanguage;    
    
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const langParam = urlParams.get('lang');

        if (langParam) {
            const matchingLanguage = content.languages.find(([lang, url]) => lang === langParam);
            if (matchingLanguage) {
                const [_, url] = matchingLanguage;
                window.location.href = `${url}`;
            }
        }
        

        const handleButtonClick = (event: any) => {
            if (event.target.classList.contains('cta')) {
                console.log("CTA clicked")
                trackEvent("Blog > CTA Clicked");
                window.location.href = "/login?signup=true"
            }
        };

        const parentElement = document.getElementById('blog-wrapper');
        if (parentElement) {
            document.addEventListener('click', handleButtonClick);
        }

        return () => {
            if (parentElement) {
                parentElement.removeEventListener('click', handleButtonClick);
            }
        };
    }, []);

    return (
        <Box bg="gray.0">
            <Head>
                <meta charSet="utf-8" />
                <title>{content.properties.title}</title>
                <link rel="canonical" href={`https://calensync.live${content.properties.url}`} />
                {content.languages.map(([language, url]) => (
                    <link rel="alternate" key={language} href={`https://calensync.live${url}`} hrefLang={language} />
                ))}
                <meta name="description" content={content.properties.description} />
                <meta property="og:title" content={content.properties.title} />
                <meta property="og:url" content={`https://calensync.live${content.properties.url}`} />
                <meta property="og:description" content={content.properties.description} />
                <meta property="og:publish_date" content={content.properties.publishDate} />
            </Head>
            <Container size="md" mt="md" id="blog-wrapper">
                <Paper p="md" my="md" bg="gray.0">
                    <Box mb="md" mt="md">
                        <Title order={1} mb="xs">{content.properties.title}</Title>
                        <Text fs="italic" c="dimmed">{content.properties.date}</Text>
                    </Box>

                    <Box mb="xl">
                        <MarkDown
                            rehypePlugins={[rehypeRaw]}
                            children={content.markdown}
                            components={{
                                h1(props) {
                                    const { children } = props
                                    return <Title order={1}>{children}</Title>
                                },
                                p(props) {
                                    const { children } = props
                                    return <Text size="lg" mb="md">
                                        {children}
                                    </Text>
                                },
                                strong(props) {
                                    const { children } = props
                                    return <Text span fw={700}><b>{children}</b></Text>
                                },
                                h2(props) {
                                    const { children } = props
                                    return <Title fw={400} order={2} mt="xl" pt="md" pb="md">{children}</Title>
                                },
                                h3(props) {
                                    const { children } = props
                                    return <Title fz="xl" fw={300} order={3} mt="md" pt="sm" pb="sm">{children}</Title>
                                },
                                img(props) {
                                    const { src, alt, style, width } = props
                                    return <Image
                                        mx="auto"
                                        my="sm"
                                        src={src}
                                        alt={alt}
                                        style={style}
                                        w={width}
                                        radius="md"
                                    />
                                },
                                a(props) {
                                    const { children, href } = props
                                    if (typeof children === 'string' && children.includes('CUSTOM_BUTTON')) {
                                        const content = children.replace('CUSTOM_BUTTON:', '')
                                        const onClick = () => {
                                            console.log("CTA clicked")
                                            trackEvent("Blog > CTA Clicked");
                                            redirectWithParameters('login', { signup: 'true' }, true)
                                        }
                                        return (
                                            <Group justify='center' my='md'>
                                                <Stack justify='center' my='md' gap="0">
                                                    <Button color="primary.4" size="compact-md" className="cta" onClick={onClick}>{content}</Button>
                                                    <Text size="sm" c="dimmed">.. and get 7 days free trial</Text>
                                                </Stack>
                                            </Group>
                                        )
                                    } else if (href.toLowerCase().startsWith('blog/')) {
                                        const blogId = href.toLowerCase().replace('blog/', '')
                                        const content = getBlogByLanguage(blogs[blogId], matchingLanguageCode)
                                        return <Anchor href={content.url}>{children}</Anchor>
                                    } else {
                                        return <Anchor href={href}>{children}</Anchor>
                                    }
                                }
                            }}
                        />
                    </Box>
                    {content.properties.readMore && (
                        <MoreFromOurBlog 
                            blogs={content.properties.readMore.map((blogId) => blogs[blogId])} 
                            matchingLanguageCode={matchingLanguageCode} 
                        />
                    )}
                </Paper>
            </Container>
        </Box>
    );
};

const BlogTemplate: React.FC = () => {
    return (
        <Layout>
            <InnerBlogTemplate />
        </Layout>
    );
};

export default BlogTemplate;